import React, { useEffect } from 'react';
import Layout from '../layouts/Layout';
import { PUBLIC_URL } from '../utils/const';
import { BlogLanguageWrapper, BlogPage } from 'reactyll';
import MarkDown from 'react-markdown'
import rehypeRaw from 'rehype-raw';
import { Head } from 'vite-react-ssg';
import { useFathom } from '../contexts/FathomContext';
import { Container, Title, Text, Image, Box, Paper, Anchor, Group, Button, Stack, Divider } from '@mantine/core';
import { redirectWithParameters } from '../utils/common';
import { getBlogByLanguage } from '../utils/blog';
import { blogs } from '../_blog/routes';
import { useTranslation } from 'react-i18next';
import MoreFromOurBlog from '../components/MoreFromOurBlog';

export interface ExtraProperties {
    date: string
    headline: string
    description: string
    publishDate: string
    readMore?: string[]
}

const content: BlogPage<ExtraProperties> = JSON.parse(decodeURIComponent(atob(`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`)));


const InnerBlogTemplate: React.FC = () => {
    const { trackEvent } = useFathom();
    const { i18n } = useTranslation();

    const matchingLanguageCode = content.properties.language || i18n.resolvedLanguage;    
    
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const langParam = urlParams.get('lang');

        if (langParam) {
            const matchingLanguage = content.languages.find(([lang, url]) => lang === langParam);
            if (matchingLanguage) {
                const [_, url] = matchingLanguage;
                window.location.href = `${url}`;
            }
        }
        

        const handleButtonClick = (event: any) => {
            if (event.target.classList.contains('cta')) {
                console.log("CTA clicked")
                trackEvent("Blog > CTA Clicked");
                window.location.href = "/login?signup=true"
            }
        };

        const parentElement = document.getElementById('blog-wrapper');
        if (parentElement) {
            document.addEventListener('click', handleButtonClick);
        }

        return () => {
            if (parentElement) {
                parentElement.removeEventListener('click', handleButtonClick);
            }
        };
    }, []);

    return (
        <Box bg="gray.0">
            <Head>
                <meta charSet="utf-8" />
                <title>{content.properties.title}</title>
                <link rel="canonical" href={`https://calensync.live${content.properties.url}`} />
                {content.languages.map(([language, url]) => (
                    <link rel="alternate" key={language} href={`https://calensync.live${url}`} hrefLang={language} />
                ))}
                <meta name="description" content={content.properties.description} />
                <meta property="og:title" content={content.properties.title} />
                <meta property="og:url" content={`https://calensync.live${content.properties.url}`} />
                <meta property="og:description" content={content.properties.description} />
                <meta property="og:publish_date" content={content.properties.publishDate} />
            </Head>
            <Container size="md" mt="md" id="blog-wrapper">
                <Paper p="md" my="md" bg="gray.0">
                    <Box mb="md" mt="md">
                        <Title order={1} mb="xs">{content.properties.title}</Title>
                        <Text fs="italic" c="dimmed">{content.properties.date}</Text>
                    </Box>

                    <Box mb="xl">
                        <MarkDown
                            rehypePlugins={[rehypeRaw]}
                            children={content.markdown}
                            components={{
                                h1(props) {
                                    const { children } = props
                                    return <Title order={1}>{children}</Title>
                                },
                                p(props) {
                                    const { children } = props
                                    return <Text size="lg" mb="md">
                                        {children}
                                    </Text>
                                },
                                strong(props) {
                                    const { children } = props
                                    return <Text span fw={700}><b>{children}</b></Text>
                                },
                                h2(props) {
                                    const { children } = props
                                    return <Title fw={400} order={2} mt="xl" pt="md" pb="md">{children}</Title>
                                },
                                h3(props) {
                                    const { children } = props
                                    return <Title fz="xl" fw={300} order={3} mt="md" pt="sm" pb="sm">{children}</Title>
                                },
                                img(props) {
                                    const { src, alt, style, width } = props
                                    return <Image
                                        mx="auto"
                                        my="sm"
                                        src={src}
                                        alt={alt}
                                        style={style}
                                        w={width}
                                        radius="md"
                                    />
                                },
                                a(props) {
                                    const { children, href } = props
                                    if (typeof children === 'string' && children.includes('CUSTOM_BUTTON')) {
                                        const content = children.replace('CUSTOM_BUTTON:', '')
                                        const onClick = () => {
                                            console.log("CTA clicked")
                                            trackEvent("Blog > CTA Clicked");
                                            redirectWithParameters('login', { signup: 'true' }, true)
                                        }
                                        return (
                                            <Group justify='center' my='md'>
                                                <Stack justify='center' my='md' gap="0">
                                                    <Button color="primary.4" size="compact-md" className="cta" onClick={onClick}>{content}</Button>
                                                    <Text size="sm" c="dimmed">.. and get 7 days free trial</Text>
                                                </Stack>
                                            </Group>
                                        )
                                    } else if (href.toLowerCase().startsWith('blog/')) {
                                        const blogId = href.toLowerCase().replace('blog/', '')
                                        const content = getBlogByLanguage(blogs[blogId], matchingLanguageCode)
                                        return <Anchor href={content.url}>{children}</Anchor>
                                    } else {
                                        return <Anchor href={href}>{children}</Anchor>
                                    }
                                }
                            }}
                        />
                    </Box>
                    {content.properties.readMore && (
                        <MoreFromOurBlog 
                            blogs={content.properties.readMore.map((blogId) => blogs[blogId])} 
                            matchingLanguageCode={matchingLanguageCode} 
                        />
                    )}
                </Paper>
            </Container>
        </Box>
    );
};

const BlogTemplate: React.FC = () => {
    return (
        <Layout>
            <InnerBlogTemplate />
        </Layout>
    );
};

export default BlogTemplate;